import React, { useEffect } from 'react';
import Layout from '../layouts/Layout';
import { PUBLIC_URL } from '../utils/const';
import { BlogLanguageWrapper, BlogPage } from 'reactyll';
import MarkDown from 'react-markdown'
import rehypeRaw from 'rehype-raw';
import { Head } from 'vite-react-ssg';
import { useFathom } from '../contexts/FathomContext';
import { Container, Title, Text, Image, Box, Paper, Anchor, Group, Button, Stack, Divider } from '@mantine/core';
import { redirectWithParameters } from '../utils/common';
import { getBlogByLanguage } from '../utils/blog';
import { blogs } from '../_blog/routes';
import { useTranslation } from 'react-i18next';
import MoreFromOurBlog from '../components/MoreFromOurBlog';

export interface ExtraProperties {
    date: string
    headline: string
    description: string
    publishDate: string
    readMore?: string[]
}

const content: BlogPage<ExtraProperties> = JSON.parse(decodeURIComponent(atob(`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`)));


const InnerBlogTemplate: React.FC = () => {
    const { trackEvent } = useFathom();
    const { i18n } = useTranslation();

    const matchingLanguageCode = content.properties.language || i18n.resolvedLanguage;    
    
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const langParam = urlParams.get('lang');

        if (langParam) {
            const matchingLanguage = content.languages.find(([lang, url]) => lang === langParam);
            if (matchingLanguage) {
                const [_, url] = matchingLanguage;
                window.location.href = `${url}`;
            }
        }
        

        const handleButtonClick = (event: any) => {
            if (event.target.classList.contains('cta')) {
                console.log("CTA clicked")
                trackEvent("Blog > CTA Clicked");
                window.location.href = "/login?signup=true"
            }
        };

        const parentElement = document.getElementById('blog-wrapper');
        if (parentElement) {
            document.addEventListener('click', handleButtonClick);
        }

        return () => {
            if (parentElement) {
                parentElement.removeEventListener('click', handleButtonClick);
            }
        };
    }, []);

    return (
        <Box bg="gray.0">
            <Head>
                <meta charSet="utf-8" />
                <title>{content.properties.title}</title>
                <link rel="canonical" href={`https://calensync.live${content.properties.url}`} />
                {content.languages.map(([language, url]) => (
                    <link rel="alternate" key={language} href={`https://calensync.live${url}`} hrefLang={language} />
                ))}
                <meta name="description" content={content.properties.description} />
                <meta property="og:title" content={content.properties.title} />
                <meta property="og:url" content={`https://calensync.live${content.properties.url}`} />
                <meta property="og:description" content={content.properties.description} />
                <meta property="og:publish_date" content={content.properties.publishDate} />
            </Head>
            <Container size="md" mt="md" id="blog-wrapper">
                <Paper p="md" my="md" bg="gray.0">
                    <Box mb="md" mt="md">
                        <Title order={1} mb="xs">{content.properties.title}</Title>
                        <Text fs="italic" c="dimmed">{content.properties.date}</Text>
                    </Box>

                    <Box mb="xl">
                        <MarkDown
                            rehypePlugins={[rehypeRaw]}
                            children={content.markdown}
                            components={{
                                h1(props) {
                                    const { children } = props
                                    return <Title order={1}>{children}</Title>
                                },
                                p(props) {
                                    const { children } = props
                                    return <Text size="lg" mb="md">
                                        {children}
                                    </Text>
                                },
                                strong(props) {
                                    const { children } = props
                                    return <Text span fw={700}><b>{children}</b></Text>
                                },
                                h2(props) {
                                    const { children } = props
                                    return <Title fw={400} order={2} mt="xl" pt="md" pb="md">{children}</Title>
                                },
                                h3(props) {
                                    const { children } = props
                                    return <Title fz="xl" fw={300} order={3} mt="md" pt="sm" pb="sm">{children}</Title>
                                },
                                img(props) {
                                    const { src, alt, style, width } = props
                                    return <Image
                                        mx="auto"
                                        my="sm"
                                        src={src}
                                        alt={alt}
                                        style={style}
                                        w={width}
                                        radius="md"
                                    />
                                },
                                a(props) {
                                    const { children, href } = props
                                    if (typeof children === 'string' && children.includes('CUSTOM_BUTTON')) {
                                        const content = children.replace('CUSTOM_BUTTON:', '')
                                        const onClick = () => {
                                            console.log("CTA clicked")
                                            trackEvent("Blog > CTA Clicked");
                                            redirectWithParameters('login', { signup: 'true' }, true)
                                        }
                                        return (
                                            <Group justify='center' my='md'>
                                                <Stack justify='center' my='md' gap="0">
                                                    <Button color="primary.4" size="compact-md" className="cta" onClick={onClick}>{content}</Button>
                                                    <Text size="sm" c="dimmed">.. and get 7 days free trial</Text>
                                                </Stack>
                                            </Group>
                                        )
                                    } else if (href.toLowerCase().startsWith('blog/')) {
                                        const blogId = href.toLowerCase().replace('blog/', '')
                                        const content = getBlogByLanguage(blogs[blogId], matchingLanguageCode)
                                        return <Anchor href={content.url}>{children}</Anchor>
                                    } else {
                                        return <Anchor href={href}>{children}</Anchor>
                                    }
                                }
                            }}
                        />
                    </Box>
                    {content.properties.readMore && (
                        <MoreFromOurBlog 
                            blogs={content.properties.readMore.map((blogId) => blogs[blogId])} 
                            matchingLanguageCode={matchingLanguageCode} 
                        />
                    )}
                </Paper>
            </Container>
        </Box>
    );
};

const BlogTemplate: React.FC = () => {
    return (
        <Layout>
            <InnerBlogTemplate />
        </Layout>
    );
};

export default BlogTemplate;